import React, { useEffect } from 'react';
import Layout from '../layouts/Layout';
import { PUBLIC_URL } from '../utils/const';
import { BlogLanguageWrapper, BlogPage } from 'reactyll';
import MarkDown from 'react-markdown'
import rehypeRaw from 'rehype-raw';
import { Head } from 'vite-react-ssg';
import { useFathom } from '../contexts/FathomContext';
import { Container, Title, Text, Image, Box, Paper, Anchor, Group, Button, Stack, Divider } from '@mantine/core';
import { redirectWithParameters } from '../utils/common';
import { getBlogByLanguage } from '../utils/blog';
import { blogs } from '../_blog/routes';
import { useTranslation } from 'react-i18next';
import MoreFromOurBlog from '../components/MoreFromOurBlog';

export interface ExtraProperties {
    date: string
    headline: string
    description: string
    publishDate: string
    readMore?: string[]
}

const content: BlogPage<ExtraProperties> = JSON.parse(decodeURIComponent(atob(`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`)));


const InnerBlogTemplate: React.FC = () => {
    const { trackEvent } = useFathom();
    const { i18n } = useTranslation();

    const matchingLanguageCode = content.properties.language || i18n.resolvedLanguage;    
    
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const langParam = urlParams.get('lang');

        if (langParam) {
            const matchingLanguage = content.languages.find(([lang, url]) => lang === langParam);
            if (matchingLanguage) {
                const [_, url] = matchingLanguage;
                window.location.href = `${url}`;
            }
        }
        

        const handleButtonClick = (event: any) => {
            if (event.target.classList.contains('cta')) {
                console.log("CTA clicked")
                trackEvent("Blog > CTA Clicked");
                window.location.href = "/login?signup=true"
            }
        };

        const parentElement = document.getElementById('blog-wrapper');
        if (parentElement) {
            document.addEventListener('click', handleButtonClick);
        }

        return () => {
            if (parentElement) {
                parentElement.removeEventListener('click', handleButtonClick);
            }
        };
    }, []);

    return (
        <Box bg="gray.0">
            <Head>
                <meta charSet="utf-8" />
                <title>{content.properties.title}</title>
                <link rel="canonical" href={`https://calensync.live${content.properties.url}`} />
                {content.languages.map(([language, url]) => (
                    <link rel="alternate" key={language} href={`https://calensync.live${url}`} hrefLang={language} />
                ))}
                <meta name="description" content={content.properties.description} />
                <meta property="og:title" content={content.properties.title} />
                <meta property="og:url" content={`https://calensync.live${content.properties.url}`} />
                <meta property="og:description" content={content.properties.description} />
                <meta property="og:publish_date" content={content.properties.publishDate} />
            </Head>
            <Container size="md" mt="md" id="blog-wrapper">
                <Paper p="md" my="md" bg="gray.0">
                    <Box mb="md" mt="md">
                        <Title order={1} mb="xs">{content.properties.title}</Title>
                        <Text fs="italic" c="dimmed">{content.properties.date}</Text>
                    </Box>

                    <Box mb="xl">
                        <MarkDown
                            rehypePlugins={[rehypeRaw]}
                            children={content.markdown}
                            components={{
                                h1(props) {
                                    const { children } = props
                                    return <Title order={1}>{children}</Title>
                                },
                                p(props) {
                                    const { children } = props
                                    return <Text size="lg" mb="md">
                                        {children}
                                    </Text>
                                },
                                strong(props) {
                                    const { children } = props
                                    return <Text span fw={700}><b>{children}</b></Text>
                                },
                                h2(props) {
                                    const { children } = props
                                    return <Title fw={400} order={2} mt="xl" pt="md" pb="md">{children}</Title>
                                },
                                h3(props) {
                                    const { children } = props
                                    return <Title fz="xl" fw={300} order={3} mt="md" pt="sm" pb="sm">{children}</Title>
                                },
                                img(props) {
                                    const { src, alt, style, width } = props
                                    return <Image
                                        mx="auto"
                                        my="sm"
                                        src={src}
                                        alt={alt}
                                        style={style}
                                        w={width}
                                        radius="md"
                                    />
                                },
                                a(props) {
                                    const { children, href } = props
                                    if (typeof children === 'string' && children.includes('CUSTOM_BUTTON')) {
                                        const content = children.replace('CUSTOM_BUTTON:', '')
                                        const onClick = () => {
                                            console.log("CTA clicked")
                                            trackEvent("Blog > CTA Clicked");
                                            redirectWithParameters('login', { signup: 'true' }, true)
                                        }
                                        return (
                                            <Group justify='center' my='md'>
                                                <Stack justify='center' my='md' gap="0">
                                                    <Button color="primary.4" size="compact-md" className="cta" onClick={onClick}>{content}</Button>
                                                    <Text size="sm" c="dimmed">.. and get 7 days free trial</Text>
                                                </Stack>
                                            </Group>
                                        )
                                    } else if (href.toLowerCase().startsWith('blog/')) {
                                        const blogId = href.toLowerCase().replace('blog/', '')
                                        const content = getBlogByLanguage(blogs[blogId], matchingLanguageCode)
                                        return <Anchor href={content.url}>{children}</Anchor>
                                    } else {
                                        return <Anchor href={href}>{children}</Anchor>
                                    }
                                }
                            }}
                        />
                    </Box>
                    {content.properties.readMore && (
                        <MoreFromOurBlog 
                            blogs={content.properties.readMore.map((blogId) => blogs[blogId])} 
                            matchingLanguageCode={matchingLanguageCode} 
                        />
                    )}
                </Paper>
            </Container>
        </Box>
    );
};

const BlogTemplate: React.FC = () => {
    return (
        <Layout>
            <InnerBlogTemplate />
        </Layout>
    );
};

export default BlogTemplate;